import React, { useEffect } from 'react';
import Layout from '../layouts/Layout';
import { PUBLIC_URL } from '../utils/const';
import { BlogLanguageWrapper, BlogPage } from 'reactyll';
import MarkDown from 'react-markdown'
import rehypeRaw from 'rehype-raw';
import { Head } from 'vite-react-ssg';
import { useFathom } from '../contexts/FathomContext';
import { Container, Title, Text, Image, Box, Paper, Anchor, Group, Button, Stack, Divider } from '@mantine/core';
import { redirectWithParameters } from '../utils/common';
import { getBlogByLanguage } from '../utils/blog';
import { blogs } from '../_blog/routes';
import { useTranslation } from 'react-i18next';
import MoreFromOurBlog from '../components/MoreFromOurBlog';

export interface ExtraProperties {
    date: string
    headline: string
    description: string
    publishDate: string
    readMore?: string[]
}

const content: BlogPage<ExtraProperties> = JSON.parse(decodeURIComponent(atob(`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`)));


const InnerBlogTemplate: React.FC = () => {
    const { trackEvent } = useFathom();
    const { i18n } = useTranslation();

    const matchingLanguageCode = content.properties.language || i18n.resolvedLanguage;    
    
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const langParam = urlParams.get('lang');

        if (langParam) {
            const matchingLanguage = content.languages.find(([lang, url]) => lang === langParam);
            if (matchingLanguage) {
                const [_, url] = matchingLanguage;
                window.location.href = `${url}`;
            }
        }
        

        const handleButtonClick = (event: any) => {
            if (event.target.classList.contains('cta')) {
                console.log("CTA clicked")
                trackEvent("Blog > CTA Clicked");
                window.location.href = "/login?signup=true"
            }
        };

        const parentElement = document.getElementById('blog-wrapper');
        if (parentElement) {
            document.addEventListener('click', handleButtonClick);
        }

        return () => {
            if (parentElement) {
                parentElement.removeEventListener('click', handleButtonClick);
            }
        };
    }, []);

    return (
        <Box bg="gray.0">
            <Head>
                <meta charSet="utf-8" />
                <title>{content.properties.title}</title>
                <link rel="canonical" href={`https://calensync.live${content.properties.url}`} />
                {content.languages.map(([language, url]) => (
                    <link rel="alternate" key={language} href={`https://calensync.live${url}`} hrefLang={language} />
                ))}
                <meta name="description" content={content.properties.description} />
                <meta property="og:title" content={content.properties.title} />
                <meta property="og:url" content={`https://calensync.live${content.properties.url}`} />
                <meta property="og:description" content={content.properties.description} />
                <meta property="og:publish_date" content={content.properties.publishDate} />
            </Head>
            <Container size="md" mt="md" id="blog-wrapper">
                <Paper p="md" my="md" bg="gray.0">
                    <Box mb="md" mt="md">
                        <Title order={1} mb="xs">{content.properties.title}</Title>
                        <Text fs="italic" c="dimmed">{content.properties.date}</Text>
                    </Box>

                    <Box mb="xl">
                        <MarkDown
                            rehypePlugins={[rehypeRaw]}
                            children={content.markdown}
                            components={{
                                h1(props) {
                                    const { children } = props
                                    return <Title order={1}>{children}</Title>
                                },
                                p(props) {
                                    const { children } = props
                                    return <Text size="lg" mb="md">
                                        {children}
                                    </Text>
                                },
                                strong(props) {
                                    const { children } = props
                                    return <Text span fw={700}><b>{children}</b></Text>
                                },
                                h2(props) {
                                    const { children } = props
                                    return <Title fw={400} order={2} mt="xl" pt="md" pb="md">{children}</Title>
                                },
                                h3(props) {
                                    const { children } = props
                                    return <Title fz="xl" fw={300} order={3} mt="md" pt="sm" pb="sm">{children}</Title>
                                },
                                img(props) {
                                    const { src, alt, style, width } = props
                                    return <Image
                                        mx="auto"
                                        my="sm"
                                        src={src}
                                        alt={alt}
                                        style={style}
                                        w={width}
                                        radius="md"
                                    />
                                },
                                a(props) {
                                    const { children, href } = props
                                    if (typeof children === 'string' && children.includes('CUSTOM_BUTTON')) {
                                        const content = children.replace('CUSTOM_BUTTON:', '')
                                        const onClick = () => {
                                            console.log("CTA clicked")
                                            trackEvent("Blog > CTA Clicked");
                                            redirectWithParameters('login', { signup: 'true' }, true)
                                        }
                                        return (
                                            <Group justify='center' my='md'>
                                                <Stack justify='center' my='md' gap="0">
                                                    <Button color="primary.4" size="compact-md" className="cta" onClick={onClick}>{content}</Button>
                                                    <Text size="sm" c="dimmed">.. and get 7 days free trial</Text>
                                                </Stack>
                                            </Group>
                                        )
                                    } else if (href.toLowerCase().startsWith('blog/')) {
                                        const blogId = href.toLowerCase().replace('blog/', '')
                                        const content = getBlogByLanguage(blogs[blogId], matchingLanguageCode)
                                        return <Anchor href={content.url}>{children}</Anchor>
                                    } else {
                                        return <Anchor href={href}>{children}</Anchor>
                                    }
                                }
                            }}
                        />
                    </Box>
                    {content.properties.readMore && (
                        <MoreFromOurBlog 
                            blogs={content.properties.readMore.map((blogId) => blogs[blogId])} 
                            matchingLanguageCode={matchingLanguageCode} 
                        />
                    )}
                </Paper>
            </Container>
        </Box>
    );
};

const BlogTemplate: React.FC = () => {
    return (
        <Layout>
            <InnerBlogTemplate />
        </Layout>
    );
};

export default BlogTemplate;